import React, { useEffect } from 'react';
import Layout from '../layouts/Layout';
import { PUBLIC_URL } from '../utils/const';
import { BlogLanguageWrapper, BlogPage } from 'reactyll';
import MarkDown from 'react-markdown'
import rehypeRaw from 'rehype-raw';
import { Head } from 'vite-react-ssg';
import { useFathom } from '../contexts/FathomContext';
import { Container, Title, Text, Image, Box, Paper, Anchor, Group, Button, Stack, Divider } from '@mantine/core';
import { redirectWithParameters } from '../utils/common';
import { getBlogByLanguage } from '../utils/blog';
import { blogs } from '../_blog/routes';
import { useTranslation } from 'react-i18next';
import MoreFromOurBlog from '../components/MoreFromOurBlog';

export interface ExtraProperties {
    date: string
    headline: string
    description: string
    publishDate: string
    readMore?: string[]
}

const content: BlogPage<ExtraProperties> = JSON.parse(decodeURIComponent(atob(`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`)));


const InnerBlogTemplate: React.FC = () => {
    const { trackEvent } = useFathom();
    const { i18n } = useTranslation();

    const matchingLanguageCode = content.properties.language || i18n.resolvedLanguage;    
    
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const langParam = urlParams.get('lang');

        if (langParam) {
            const matchingLanguage = content.languages.find(([lang, url]) => lang === langParam);
            if (matchingLanguage) {
                const [_, url] = matchingLanguage;
                window.location.href = `${url}`;
            }
        }
        

        const handleButtonClick = (event: any) => {
            if (event.target.classList.contains('cta')) {
                console.log("CTA clicked")
                trackEvent("Blog > CTA Clicked");
                window.location.href = "/login?signup=true"
            }
        };

        const parentElement = document.getElementById('blog-wrapper');
        if (parentElement) {
            document.addEventListener('click', handleButtonClick);
        }

        return () => {
            if (parentElement) {
                parentElement.removeEventListener('click', handleButtonClick);
            }
        };
    }, []);

    return (
        <Box bg="gray.0">
            <Head>
                <meta charSet="utf-8" />
                <title>{content.properties.title}</title>
                <link rel="canonical" href={`https://calensync.live${content.properties.url}`} />
                {content.languages.map(([language, url]) => (
                    <link rel="alternate" key={language} href={`https://calensync.live${url}`} hrefLang={language} />
                ))}
                <meta name="description" content={content.properties.description} />
                <meta property="og:title" content={content.properties.title} />
                <meta property="og:url" content={`https://calensync.live${content.properties.url}`} />
                <meta property="og:description" content={content.properties.description} />
                <meta property="og:publish_date" content={content.properties.publishDate} />
            </Head>
            <Container size="md" mt="md" id="blog-wrapper">
                <Paper p="md" my="md" bg="gray.0">
                    <Box mb="md" mt="md">
                        <Title order={1} mb="xs">{content.properties.title}</Title>
                        <Text fs="italic" c="dimmed">{content.properties.date}</Text>
                    </Box>

                    <Box mb="xl">
                        <MarkDown
                            rehypePlugins={[rehypeRaw]}
                            children={content.markdown}
                            components={{
                                h1(props) {
                                    const { children } = props
                                    return <Title order={1}>{children}</Title>
                                },
                                p(props) {
                                    const { children } = props
                                    return <Text size="lg" mb="md">
                                        {children}
                                    </Text>
                                },
                                strong(props) {
                                    const { children } = props
                                    return <Text span fw={700}><b>{children}</b></Text>
                                },
                                h2(props) {
                                    const { children } = props
                                    return <Title fw={400} order={2} mt="xl" pt="md" pb="md">{children}</Title>
                                },
                                h3(props) {
                                    const { children } = props
                                    return <Title fz="xl" fw={300} order={3} mt="md" pt="sm" pb="sm">{children}</Title>
                                },
                                img(props) {
                                    const { src, alt, style, width } = props
                                    return <Image
                                        mx="auto"
                                        my="sm"
                                        src={src}
                                        alt={alt}
                                        style={style}
                                        w={width}
                                        radius="md"
                                    />
                                },
                                a(props) {
                                    const { children, href } = props
                                    if (typeof children === 'string' && children.includes('CUSTOM_BUTTON')) {
                                        const content = children.replace('CUSTOM_BUTTON:', '')
                                        const onClick = () => {
                                            console.log("CTA clicked")
                                            trackEvent("Blog > CTA Clicked");
                                            redirectWithParameters('login', { signup: 'true' }, true)
                                        }
                                        return (
                                            <Group justify='center' my='md'>
                                                <Stack justify='center' my='md' gap="0">
                                                    <Button color="primary.4" size="compact-md" className="cta" onClick={onClick}>{content}</Button>
                                                    <Text size="sm" c="dimmed">.. and get 7 days free trial</Text>
                                                </Stack>
                                            </Group>
                                        )
                                    } else if (href.toLowerCase().startsWith('blog/')) {
                                        const blogId = href.toLowerCase().replace('blog/', '')
                                        const content = getBlogByLanguage(blogs[blogId], matchingLanguageCode)
                                        return <Anchor href={content.url}>{children}</Anchor>
                                    } else {
                                        return <Anchor href={href}>{children}</Anchor>
                                    }
                                }
                            }}
                        />
                    </Box>
                    {content.properties.readMore && (
                        <MoreFromOurBlog 
                            blogs={content.properties.readMore.map((blogId) => blogs[blogId])} 
                            matchingLanguageCode={matchingLanguageCode} 
                        />
                    )}
                </Paper>
            </Container>
        </Box>
    );
};

const BlogTemplate: React.FC = () => {
    return (
        <Layout>
            <InnerBlogTemplate />
        </Layout>
    );
};

export default BlogTemplate;